import React, { useEffect } from 'react';
import Layout from '../layouts/Layout';
import { PUBLIC_URL } from '../utils/const';
import { BlogLanguageWrapper, BlogPage } from 'reactyll';
import MarkDown from 'react-markdown'
import rehypeRaw from 'rehype-raw';
import { Head } from 'vite-react-ssg';
import { useFathom } from '../contexts/FathomContext';
import { Container, Title, Text, Image, Box, Paper, Anchor, Group, Button, Stack, Divider } from '@mantine/core';
import { redirectWithParameters } from '../utils/common';
import { getBlogByLanguage } from '../utils/blog';
import { blogs } from '../_blog/routes';
import { useTranslation } from 'react-i18next';
import MoreFromOurBlog from '../components/MoreFromOurBlog';

export interface ExtraProperties {
    date: string
    headline: string
    description: string
    publishDate: string
    readMore?: string[]
}

const content: BlogPage<ExtraProperties> = JSON.parse(decodeURIComponent(atob(`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`)));


const InnerBlogTemplate: React.FC = () => {
    const { trackEvent } = useFathom();
    const { i18n } = useTranslation();

    const matchingLanguageCode = content.properties.language || i18n.resolvedLanguage;    
    
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const langParam = urlParams.get('lang');

        if (langParam) {
            const matchingLanguage = content.languages.find(([lang, url]) => lang === langParam);
            if (matchingLanguage) {
                const [_, url] = matchingLanguage;
                window.location.href = `${url}`;
            }
        }
        

        const handleButtonClick = (event: any) => {
            if (event.target.classList.contains('cta')) {
                console.log("CTA clicked")
                trackEvent("Blog > CTA Clicked");
                window.location.href = "/login?signup=true"
            }
        };

        const parentElement = document.getElementById('blog-wrapper');
        if (parentElement) {
            document.addEventListener('click', handleButtonClick);
        }

        return () => {
            if (parentElement) {
                parentElement.removeEventListener('click', handleButtonClick);
            }
        };
    }, []);

    return (
        <Box bg="gray.0">
            <Head>
                <meta charSet="utf-8" />
                <title>{content.properties.title}</title>
                <link rel="canonical" href={`https://calensync.live${content.properties.url}`} />
                {content.languages.map(([language, url]) => (
                    <link rel="alternate" key={language} href={`https://calensync.live${url}`} hrefLang={language} />
                ))}
                <meta name="description" content={content.properties.description} />
                <meta property="og:title" content={content.properties.title} />
                <meta property="og:url" content={`https://calensync.live${content.properties.url}`} />
                <meta property="og:description" content={content.properties.description} />
                <meta property="og:publish_date" content={content.properties.publishDate} />
            </Head>
            <Container size="md" mt="md" id="blog-wrapper">
                <Paper p="md" my="md" bg="gray.0">
                    <Box mb="md" mt="md">
                        <Title order={1} mb="xs">{content.properties.title}</Title>
                        <Text fs="italic" c="dimmed">{content.properties.date}</Text>
                    </Box>

                    <Box mb="xl">
                        <MarkDown
                            rehypePlugins={[rehypeRaw]}
                            children={content.markdown}
                            components={{
                                h1(props) {
                                    const { children } = props
                                    return <Title order={1}>{children}</Title>
                                },
                                p(props) {
                                    const { children } = props
                                    return <Text size="lg" mb="md">
                                        {children}
                                    </Text>
                                },
                                strong(props) {
                                    const { children } = props
                                    return <Text span fw={700}><b>{children}</b></Text>
                                },
                                h2(props) {
                                    const { children } = props
                                    return <Title fw={400} order={2} mt="xl" pt="md" pb="md">{children}</Title>
                                },
                                h3(props) {
                                    const { children } = props
                                    return <Title fz="xl" fw={300} order={3} mt="md" pt="sm" pb="sm">{children}</Title>
                                },
                                img(props) {
                                    const { src, alt, style, width } = props
                                    return <Image
                                        mx="auto"
                                        my="sm"
                                        src={src}
                                        alt={alt}
                                        style={style}
                                        w={width}
                                        radius="md"
                                    />
                                },
                                a(props) {
                                    const { children, href } = props
                                    if (typeof children === 'string' && children.includes('CUSTOM_BUTTON')) {
                                        const content = children.replace('CUSTOM_BUTTON:', '')
                                        const onClick = () => {
                                            console.log("CTA clicked")
                                            trackEvent("Blog > CTA Clicked");
                                            redirectWithParameters('login', { signup: 'true' }, true)
                                        }
                                        return (
                                            <Group justify='center' my='md'>
                                                <Stack justify='center' my='md' gap="0">
                                                    <Button color="primary.4" size="compact-md" className="cta" onClick={onClick}>{content}</Button>
                                                    <Text size="sm" c="dimmed">.. and get 7 days free trial</Text>
                                                </Stack>
                                            </Group>
                                        )
                                    } else if (href.toLowerCase().startsWith('blog/')) {
                                        const blogId = href.toLowerCase().replace('blog/', '')
                                        const content = getBlogByLanguage(blogs[blogId], matchingLanguageCode)
                                        return <Anchor href={content.url}>{children}</Anchor>
                                    } else {
                                        return <Anchor href={href}>{children}</Anchor>
                                    }
                                }
                            }}
                        />
                    </Box>
                    {content.properties.readMore && (
                        <MoreFromOurBlog 
                            blogs={content.properties.readMore.map((blogId) => blogs[blogId])} 
                            matchingLanguageCode={matchingLanguageCode} 
                        />
                    )}
                </Paper>
            </Container>
        </Box>
    );
};

const BlogTemplate: React.FC = () => {
    return (
        <Layout>
            <InnerBlogTemplate />
        </Layout>
    );
};

export default BlogTemplate;